import React, { useEffect } from 'react';
import Layout from '../layouts/Layout';
import { PUBLIC_URL } from '../utils/const';
import { BlogLanguageWrapper, BlogPage } from 'reactyll';
import MarkDown from 'react-markdown'
import rehypeRaw from 'rehype-raw';
import { Head } from 'vite-react-ssg';
import { useFathom } from '../contexts/FathomContext';
import { Container, Title, Text, Image, Box, Paper, Anchor, Group, Button, Stack, Divider } from '@mantine/core';
import { redirectWithParameters } from '../utils/common';
import { getBlogByLanguage } from '../utils/blog';
import { blogs } from '../_blog/routes';
import { useTranslation } from 'react-i18next';
import MoreFromOurBlog from '../components/MoreFromOurBlog';

export interface ExtraProperties {
    date: string
    headline: string
    description: string
    publishDate: string
    readMore?: string[]
}

const content: BlogPage<ExtraProperties> = JSON.parse(decodeURIComponent(atob(`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`)));


const InnerBlogTemplate: React.FC = () => {
    const { trackEvent } = useFathom();
    const { i18n } = useTranslation();

    const matchingLanguageCode = content.properties.language || i18n.resolvedLanguage;    
    
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const langParam = urlParams.get('lang');

        if (langParam) {
            const matchingLanguage = content.languages.find(([lang, url]) => lang === langParam);
            if (matchingLanguage) {
                const [_, url] = matchingLanguage;
                window.location.href = `${url}`;
            }
        }
        

        const handleButtonClick = (event: any) => {
            if (event.target.classList.contains('cta')) {
                console.log("CTA clicked")
                trackEvent("Blog > CTA Clicked");
                window.location.href = "/login?signup=true"
            }
        };

        const parentElement = document.getElementById('blog-wrapper');
        if (parentElement) {
            document.addEventListener('click', handleButtonClick);
        }

        return () => {
            if (parentElement) {
                parentElement.removeEventListener('click', handleButtonClick);
            }
        };
    }, []);

    return (
        <Box bg="gray.0">
            <Head>
                <meta charSet="utf-8" />
                <title>{content.properties.title}</title>
                <link rel="canonical" href={`https://calensync.live${content.properties.url}`} />
                {content.languages.map(([language, url]) => (
                    <link rel="alternate" key={language} href={`https://calensync.live${url}`} hrefLang={language} />
                ))}
                <meta name="description" content={content.properties.description} />
                <meta property="og:title" content={content.properties.title} />
                <meta property="og:url" content={`https://calensync.live${content.properties.url}`} />
                <meta property="og:description" content={content.properties.description} />
                <meta property="og:publish_date" content={content.properties.publishDate} />
            </Head>
            <Container size="md" mt="md" id="blog-wrapper">
                <Paper p="md" my="md" bg="gray.0">
                    <Box mb="md" mt="md">
                        <Title order={1} mb="xs">{content.properties.title}</Title>
                        <Text fs="italic" c="dimmed">{content.properties.date}</Text>
                    </Box>

                    <Box mb="xl">
                        <MarkDown
                            rehypePlugins={[rehypeRaw]}
                            children={content.markdown}
                            components={{
                                h1(props) {
                                    const { children } = props
                                    return <Title order={1}>{children}</Title>
                                },
                                p(props) {
                                    const { children } = props
                                    return <Text size="lg" mb="md">
                                        {children}
                                    </Text>
                                },
                                strong(props) {
                                    const { children } = props
                                    return <Text span fw={700}><b>{children}</b></Text>
                                },
                                h2(props) {
                                    const { children } = props
                                    return <Title fw={400} order={2} mt="xl" pt="md" pb="md">{children}</Title>
                                },
                                h3(props) {
                                    const { children } = props
                                    return <Title fz="xl" fw={300} order={3} mt="md" pt="sm" pb="sm">{children}</Title>
                                },
                                img(props) {
                                    const { src, alt, style, width } = props
                                    return <Image
                                        mx="auto"
                                        my="sm"
                                        src={src}
                                        alt={alt}
                                        style={style}
                                        w={width}
                                        radius="md"
                                    />
                                },
                                a(props) {
                                    const { children, href } = props
                                    if (typeof children === 'string' && children.includes('CUSTOM_BUTTON')) {
                                        const content = children.replace('CUSTOM_BUTTON:', '')
                                        const onClick = () => {
                                            console.log("CTA clicked")
                                            trackEvent("Blog > CTA Clicked");
                                            redirectWithParameters('login', { signup: 'true' }, true)
                                        }
                                        return (
                                            <Group justify='center' my='md'>
                                                <Stack justify='center' my='md' gap="0">
                                                    <Button color="primary.4" size="compact-md" className="cta" onClick={onClick}>{content}</Button>
                                                    <Text size="sm" c="dimmed">.. and get 7 days free trial</Text>
                                                </Stack>
                                            </Group>
                                        )
                                    } else if (href.toLowerCase().startsWith('blog/')) {
                                        const blogId = href.toLowerCase().replace('blog/', '')
                                        const content = getBlogByLanguage(blogs[blogId], matchingLanguageCode)
                                        return <Anchor href={content.url}>{children}</Anchor>
                                    } else {
                                        return <Anchor href={href}>{children}</Anchor>
                                    }
                                }
                            }}
                        />
                    </Box>
                    {content.properties.readMore && (
                        <MoreFromOurBlog 
                            blogs={content.properties.readMore.map((blogId) => blogs[blogId])} 
                            matchingLanguageCode={matchingLanguageCode} 
                        />
                    )}
                </Paper>
            </Container>
        </Box>
    );
};

const BlogTemplate: React.FC = () => {
    return (
        <Layout>
            <InnerBlogTemplate />
        </Layout>
    );
};

export default BlogTemplate;